import React, { useEffect } from 'react';
import Layout from '../layouts/Layout';
import { PUBLIC_URL } from '../utils/const';
import { BlogLanguageWrapper, BlogPage } from 'reactyll';
import MarkDown from 'react-markdown'
import rehypeRaw from 'rehype-raw';
import { Head } from 'vite-react-ssg';
import { useFathom } from '../contexts/FathomContext';
import { Container, Title, Text, Image, Box, Paper, Anchor, Group, Button, Stack, Divider } from '@mantine/core';
import { redirectWithParameters } from '../utils/common';
import { getBlogByLanguage } from '../utils/blog';
import { blogs } from '../_blog/routes';
import { useTranslation } from 'react-i18next';
import MoreFromOurBlog from '../components/MoreFromOurBlog';

export interface ExtraProperties {
    date: string
    headline: string
    description: string
    publishDate: string
    readMore?: string[]
}

const content: BlogPage<ExtraProperties> = JSON.parse(decodeURIComponent(atob(`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`)));


const InnerBlogTemplate: React.FC = () => {
    const { trackEvent } = useFathom();
    const { i18n } = useTranslation();

    const matchingLanguageCode = content.properties.language || i18n.resolvedLanguage;    
    
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const langParam = urlParams.get('lang');

        if (langParam) {
            const matchingLanguage = content.languages.find(([lang, url]) => lang === langParam);
            if (matchingLanguage) {
                const [_, url] = matchingLanguage;
                window.location.href = `${url}`;
            }
        }
        

        const handleButtonClick = (event: any) => {
            if (event.target.classList.contains('cta')) {
                console.log("CTA clicked")
                trackEvent("Blog > CTA Clicked");
                window.location.href = "/login?signup=true"
            }
        };

        const parentElement = document.getElementById('blog-wrapper');
        if (parentElement) {
            document.addEventListener('click', handleButtonClick);
        }

        return () => {
            if (parentElement) {
                parentElement.removeEventListener('click', handleButtonClick);
            }
        };
    }, []);

    return (
        <Box bg="gray.0">
            <Head>
                <meta charSet="utf-8" />
                <title>{content.properties.title}</title>
                <link rel="canonical" href={`https://calensync.live${content.properties.url}`} />
                {content.languages.map(([language, url]) => (
                    <link rel="alternate" key={language} href={`https://calensync.live${url}`} hrefLang={language} />
                ))}
                <meta name="description" content={content.properties.description} />
                <meta property="og:title" content={content.properties.title} />
                <meta property="og:url" content={`https://calensync.live${content.properties.url}`} />
                <meta property="og:description" content={content.properties.description} />
                <meta property="og:publish_date" content={content.properties.publishDate} />
            </Head>
            <Container size="md" mt="md" id="blog-wrapper">
                <Paper p="md" my="md" bg="gray.0">
                    <Box mb="md" mt="md">
                        <Title order={1} mb="xs">{content.properties.title}</Title>
                        <Text fs="italic" c="dimmed">{content.properties.date}</Text>
                    </Box>

                    <Box mb="xl">
                        <MarkDown
                            rehypePlugins={[rehypeRaw]}
                            children={content.markdown}
                            components={{
                                h1(props) {
                                    const { children } = props
                                    return <Title order={1}>{children}</Title>
                                },
                                p(props) {
                                    const { children } = props
                                    return <Text size="lg" mb="md">
                                        {children}
                                    </Text>
                                },
                                strong(props) {
                                    const { children } = props
                                    return <Text span fw={700}><b>{children}</b></Text>
                                },
                                h2(props) {
                                    const { children } = props
                                    return <Title fw={400} order={2} mt="xl" pt="md" pb="md">{children}</Title>
                                },
                                h3(props) {
                                    const { children } = props
                                    return <Title fz="xl" fw={300} order={3} mt="md" pt="sm" pb="sm">{children}</Title>
                                },
                                img(props) {
                                    const { src, alt, style, width } = props
                                    return <Image
                                        mx="auto"
                                        my="sm"
                                        src={src}
                                        alt={alt}
                                        style={style}
                                        w={width}
                                        radius="md"
                                    />
                                },
                                a(props) {
                                    const { children, href } = props
                                    if (typeof children === 'string' && children.includes('CUSTOM_BUTTON')) {
                                        const content = children.replace('CUSTOM_BUTTON:', '')
                                        const onClick = () => {
                                            console.log("CTA clicked")
                                            trackEvent("Blog > CTA Clicked");
                                            redirectWithParameters('login', { signup: 'true' }, true)
                                        }
                                        return (
                                            <Group justify='center' my='md'>
                                                <Stack justify='center' my='md' gap="0">
                                                    <Button color="primary.4" size="compact-md" className="cta" onClick={onClick}>{content}</Button>
                                                    <Text size="sm" c="dimmed">.. and get 7 days free trial</Text>
                                                </Stack>
                                            </Group>
                                        )
                                    } else if (href.toLowerCase().startsWith('blog/')) {
                                        const blogId = href.toLowerCase().replace('blog/', '')
                                        const content = getBlogByLanguage(blogs[blogId], matchingLanguageCode)
                                        return <Anchor href={content.url}>{children}</Anchor>
                                    } else {
                                        return <Anchor href={href}>{children}</Anchor>
                                    }
                                }
                            }}
                        />
                    </Box>
                    {content.properties.readMore && (
                        <MoreFromOurBlog 
                            blogs={content.properties.readMore.map((blogId) => blogs[blogId])} 
                            matchingLanguageCode={matchingLanguageCode} 
                        />
                    )}
                </Paper>
            </Container>
        </Box>
    );
};

const BlogTemplate: React.FC = () => {
    return (
        <Layout>
            <InnerBlogTemplate />
        </Layout>
    );
};

export default BlogTemplate;